//frontend/src/pages/Login.js
import React, { useState } from 'react';
import { Container, Typography, TextField, Button, Box, Paper, Alert } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../utils/axios';
import { useTranslation } from 'react-i18next';

import Turnstile from "react-turnstile";

export default function Login() {
    const { t } = useTranslation();

   const [formData, setFormData] = useState({
       email: '',
       password: '',
       captchaToken: ''
   });
   const [error, setError] = useState('');
   const [turnstileError, setTurnstileError] = useState(null);
   const navigate = useNavigate();

   const handleLogin = async (e) => {
    e.preventDefault();
    
      {/* CLOUDFLARE CAPTCHA КОМЕНТ
        
    if (!formData.captchaToken) {
        setError('Please complete the captcha');
        return;
    }

    */}

    setError('');
    
    try {
        console.log('Login attempt with:', { 
            email: formData.email, 
            hasCaptchaToken: !!formData.captchaToken,
            captchaTokenLength: formData.captchaToken?.length 
        });

        const response = await axiosInstance.post('/auth/login', formData);
        console.log('Login response:', response.data);

        if (response.data?.token) {
            localStorage.setItem('token', response.data.token);
            localStorage.setItem('userRole', response.data.user.role);
            navigate('/dashboard');
            return;
        }
        throw new Error('Invalid response format');
    } catch (error) {
        console.error('Login error:', error.response?.data || error.message);
        setError(error.response?.data?.message || 'Login failed');
    }
};

   return (
       <Container maxWidth="sm">
           <Paper elevation={3} sx={{ p: 4, mt: 4 }}>
               <Typography variant="h4" align="center" gutterBottom>
               {t('auth.login.title')}

               </Typography>

               {error && (
                   <Alert severity="error" sx={{ mb: 2 }}>
                       {error}
                   </Alert>
               )}

               <Box component="form" onSubmit={handleLogin}>
                   <TextField
                       fullWidth
                       required
                       type="email"
                       label={t('common.email')}
                       value={formData.email}
                       onChange={(e) => setFormData({...formData, email: e.target.value})}
                       margin="normal"
                       autoComplete="username"
                   />
                   <TextField
                       fullWidth
                       required
                       label={t('common.password')}
                       type="password"
                       value={formData.password}
                       onChange={(e) => setFormData({...formData, password: e.target.value})}
                       margin="normal"
                       autoComplete="current-password"
                   />
                   
                   <Box sx={{ my: 2 }}>
                       {turnstileError && (
                           <Alert severity="error" sx={{ mb: 2 }}>
                               {turnstileError}
                           </Alert>
                       )}
                       
                       {/* CLOUDFLARE CAPTCHA КОМЕНТ

                       <Turnstile
                           sitekey={process.env.REACT_APP_TURNSTILE_SITE_KEY || "0x4AAAAAAAhUcixge2JYRXG_"}
                           onVerify={(token) => {
                               console.log('Captcha verified:', !!token);
                               setFormData(prev => ({...prev, captchaToken: token}));
                               setTurnstileError(null);
                           }}
                           onError={(error) => {
                               console.error('Turnstile error:', error);
                               setTurnstileError('Error loading captcha');
                               setFormData(prev => ({...prev, captchaToken: ''}));
                           }}
                           onExpire={() => {
                               console.log('Captcha expired');
                               setFormData(prev => ({...prev, captchaToken: ''}));
                           }}
                       /> 
                       */}
                   </Box>

                   <Button
                       type="submit"
                       fullWidth
                       variant="contained"
                       sx={{ mt: 3 }}
//CLOUDFLARE комент
//  disabled={!formData.captchaToken}
                   >
    {t('common.login')}
    </Button>
               </Box>
           </Paper>
       </Container>
   );
}